<template>
    <div id="FormMultipleSelection">
        <div :class="`form-multiple-selection multiple-selection-align-${align}`">
            <input
                type="text"
                class="form-multiple-selection-title"
                :value="`${fieldLabel}`"
            >
            <div>
                <div v-for="(option, index) in multipleOptions" :key="index"
                     class="form-multiple-selection-option">
                    <input type="checkbox" :id="'multiple-option-' + index" :value="option"
                           v-model="selectedMultipleOptions">
                    <label :for="'multiple-option-' + index">{{ option }}</label>
                    <button @click="removeMultipleOption(index)" class="remove-option">X</button>
                </div>

                <input type="text" v-model="newMultipleOption" class="form-multiple-selection-new-option"
                       placeholder="Bir seçenek yazın">
                <button @click="addMultipleOption" class="form-multiple-selection-add-button">Seçenek Ekle
                </button>
                <button @click="addMultipleOtherOption" class="form-multiple-selection-add-other-button">
                    "Diğer" seçeneği ekle
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormMultipleSelection",
    props: {
        fieldLabel: String,
        align: String,
        isRequired: Boolean,
        item: Object,
    },
    data() {
        return {
            multipleOptions: [],
            selectedMultipleOptions: [],
            newMultipleOption: "",
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        addMultipleOption() {
            if (this.newMultipleOption.trim() !== "") {
                this.multipleOptions.push(this.newMultipleOption.trim());
                this.newMultipleOption = "";
                this.updateField();
            }
        },
        addMultipleOtherOption() {
            this.multipleOptions.push("Diğer");
            this.updateField();
        },
        removeMultipleOption(index) {
            this.multipleOptions.splice(index, 1);
            this.updateField();
        },
        updateField() {
            const updateFields = {
                multipleSelection: {
                    fieldLabel: this.fieldLabel,
                    align: this.align,
                    isRequired: this.isRequired,
                    items: this.multipleOptions,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
    },
    watch: {
        item: {
            handler(newItem) {
                if (newItem && newItem.multipleSelection && newItem.multipleSelection.items) {
                    this.multipleOptions = newItem.multipleSelection.items;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        if (this.item && this.item.multipleSelection && this.item.multipleSelection.items) {
            this.multipleOptions = this.item.multipleSelection.items;
        }
    },
};
</script>

<style lang="scss">
#FormMultipleSelection {
    .multiple-selection-align-left {
        display: flex;

        .form-multiple-selection-title {
            width: auto !important;
            text-align: left;
            margin-right: 10px;
        }
    }

    .multiple-selection-align-right {
        display: flex;

        .form-multiple-selection-title {
            width: auto !important;
            text-align: right;
            margin-right: 10px;
        }
    }

    .form-multiple-selection {
        cursor: all-scroll;
        margin: 20px 0;

        .form-multiple-selection-title {
            display: block;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 4px;
            width: 100%;
        }

        .form-multiple-selection-option {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            label {
                margin-bottom: 0px !important;
            }

            input[type="checkbox"] {
                margin-right: 8px;
            }

            .remove-option {
                background: none;
                border: none;
                color: #666;
                cursor: pointer;
                margin-left: 8px;
            }
        }

        .form-multiple-selection-new-option {
            display: block;
            width: 100%;
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 4px;
            font-size: 14px;
            margin-bottom: 10px;
        }

        .form-multiple-selection-add-button,
        .form-multiple-selection-add-other-button {
            display: inline-block;
            padding: 8px 16px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 14px;
            cursor: pointer;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
}
</style>
